import React from "react";
import { Container } from "react-bootstrap";
import ApiRegistryManagerPanel from "./ApiRegistryManagerPanel";

// Eigenstaendige Admin-Seite "API-Konfiguration" (unter Einstellungen).
// Buendelt die zentrale Verwaltung der Partner-APIs (Anlegen/Bearbeiten/Loeschen
// + Verbindungstest). Nutzt dieselbe Logik wie der Produkt-Tab "API"
// (ApiRegistryManagerPanel), daher keine Doppellogik. Secrets bleiben
// serverseitig (AES-256-GCM); die Routen sind mit Admin-Recht geschuetzt.
const BoardApiConfig = () => {
  return (
    <Container className="mt-3">
      <h2 className="mb-1">API-Konfiguration</h2>
      <p className="text-muted">
        Zentrale Verwaltung der Partner-Schnittstellen (z. B. voicetreff.com).
        Lege APIs an, hinterlege Zugangsdaten (Secret wird verschluesselt
        gespeichert) und pruefe die Verbindung per Handshake. Die Zuordnung einer
        API zu einem konkreten Produkt erfolgt weiterhin im Produkt-Bearbeiten-
        Dialog (Tab „API").
      </p>
      <ApiRegistryManagerPanel active={true} />
    </Container>
  );
};

export default BoardApiConfig;
